import { combineReducers } from 'redux';
import Cotizacion from 'src/reducers/Cotizacion/cotizacion.reducer';
import InputsResources from './InputsResources/inputs.reducer';
import PaginaCompraReducer, { PaginaCompraStateType, NombresArchivosSubir } from './PaginaCompra/reducers';
import PaginaPagoReducer, { PaginaPagoStateType } from './PaginaPago/reducers';

export type RootReducerType = {
  Cotizacion: any;
  PaginaCompra: PaginaCompraStateType;
  PaginaPago: PaginaPagoStateType;
  InputsResources: any;
};

export default combineReducers({
  Cotizacion,
  PaginaCompra: PaginaCompraReducer,
  PaginaPago: PaginaPagoReducer,
  InputsResources,
  NombresArchivosSubir
});
